import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { FormSelectionCardGroupField, lt } from '@mews/framework';
import { SelectField } from '@mews-commander/form';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { useRateOptions } from '@mews-commander/legacy-entities/src/queries/rates';
import { useCurrentRateGroupContext, useCurrentServiceIdContext } from '../../../contexts';
import { PolicyExceptionFormValues } from '../../../schemas';
import { FieldSectionName, PaymentPolicyFieldName } from '../types';

interface RateSelectionFieldsProps {
    policyId?: string;
    showExceptionTypeSelection?: boolean;
    disabledRates?: Record<string, true>;
}

export const RateSelectionFields = ({ showExceptionTypeSelection, disabledRates }: RateSelectionFieldsProps) => {
    const enterpriseId = useCurrentEnterpriseId();
    const serviceId = useCurrentServiceIdContext();
    const { id: rateGroupId } = useCurrentRateGroupContext();

    const { watch, setValue } = useFormContext<PolicyExceptionFormValues>();
    const exceptionType: PolicyExceptionFormValues['rates']['exceptionType'] = watch('rates.exceptionType');

    const { data: rateOptions, isFetching: isFetchingRateOptions } = useRateOptions({
        enterpriseId,
        filteredRateGroupId: rateGroupId,
        serviceId,
    });

    useEffect(() => {
        if (disabledRates && showExceptionTypeSelection) {
            // @ts-expect-error Argument of type 'string' is not assignable to parameter of type 'never'.
            setValue(`${FieldSectionName.Rates}.${PaymentPolicyFieldName.ExceptionType}`, 'rate' as const);
        }
    }, [disabledRates, setValue, showExceptionTypeSelection]);

    return (
        <>
            {showExceptionTypeSelection ? (
                <FormSelectionCardGroupField
                    name={`${FieldSectionName.Rates}.${PaymentPolicyFieldName.ExceptionType}`}
                    options={[
                        {
                            label: lt('RateGroupPolicyExceptionsEntireRateGroup'),
                            name: 'rateGroup',
                            value: 'rateGroup',
                            disabled: !!disabledRates,
                        },
                        {
                            label: lt('RateGroupPolicyExceptionsSpecificRate'),
                            name: 'rate',
                            value: 'rate',
                        },
                    ]}
                    templateColumns="1fr 1fr"
                    type="radio"
                />
            ) : null}
            {exceptionType === 'rate' ? (
                <SelectField
                    name={`${FieldSectionName.Rates}.${PaymentPolicyFieldName.Rates}`}
                    options={
                        rateOptions?.map((rateOption) => ({
                            ...rateOption,
                            disabled: !!(rateOption.value && disabledRates && disabledRates[rateOption.value]),
                        })) ?? []
                    }
                    helper={lt('PolicyExceptionFormRatesHelper')}
                    label={lt('RatePlural')}
                    loader={isFetchingRateOptions}
                    multiselect
                    required
                />
            ) : null}
        </>
    );
};
